var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "l-map",
        {
          ref: "map",
          style: _vm.mapStyling,
          attrs: {
            zoom: 10,
            minZoom: 4,
            maxZoom: 18,
            maxBounds: [
              [-90, -180],
              [90, 180],
            ],
            center: _vm.center,
            options: _vm.mapOptions,
          },
          on: {
            "update:zoom": _vm.zoomUpdated,
            "update:bounds": _vm.boundsUpdated,
          },
        },
        [
          _c("l-control", { attrs: { position: "topright", id: "v-step-0" } }, [
            _c(
              "button",
              {
                class: _vm.refreshLoading
                  ? "button is-small is-loading is-success is-outlined is-rounded is-inverted"
                  : "button is-small is-success is-outlined is-rounded is-inverted is-hovered",
                attrs: { "data-tooltip": "Left tooltip content" },
                on: { click: _vm.refresh },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "fas fa-redo has-text-success" }),
                ]),
              ]
            ),
          ]),
          _c("l-control-zoom", {
            staticClass: "leaflet-control-zoom",
            attrs: { position: "topright" },
          }),
          _c("l-tile-layer", { attrs: { url: _vm.url } }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "is-centered is-mobile has-text-centere py-3",
          staticStyle: {
            position: "fixed",
            bottom: "0",
            "z-index": "1000",
            left: "0",
            right: "0",
            "background-color": "rgba(255, 255, 255, 0.8)",
          },
        },
        [
          _c("div", { staticClass: "select is-small is-success mx-2" }, [
            _c(
              "select",
              {
                staticStyle: { width: "120px" },
                attrs: { id: "v-step-1", disabled: _vm.retrievingFSA },
                on: { change: _vm.selectRegion },
              },
              _vm._l(_vm.regions, function (option) {
                return _c(
                  "option",
                  {
                    key: option.id,
                    domProps: {
                      selected: option.id == _vm.$store.state.region,
                      value: option.id,
                    },
                  },
                  [_vm._v(" " + _vm._s(option.name) + " ")]
                )
              }),
              0
            ),
          ]),
          _vm.selectableFSAMode &&
          _vm.selectedFSAToAdd.length > 0 &&
          !_vm.editSelectableFSAMode
            ? _c(
                "button",
                {
                  staticClass: "button is-small is-success mx-2 is-outlined",
                  on: { click: _vm.openAddFSAShapeZoneModal },
                },
                [_vm._v(" Confirm FSA Zones ")]
              )
            : _vm._e(),
          _vm.selectableFSAMode &&
          _vm.selectedFSAToAdd.length > 0 &&
          _vm.editSelectableFSAMode
            ? _c(
                "button",
                {
                  staticClass: "button is-small is-success mx-2 is-outlined",
                  on: { click: _vm.openEditFSAShapeZoneModal },
                },
                [_vm._v(" Save FSA Zones ")]
              )
            : _vm._e(),
          _vm.deletePartShapeMode
            ? _c(
                "button",
                {
                  staticClass: "button is-small is-success mx-2 is-outlined",
                  on: {
                    click: function ($event) {
                      return _vm.closeAddDeletePartShapeMode()
                    },
                  },
                },
                [_vm._v(" Close Drawing Mode ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "is-small is-success button mx-2",
              attrs: {
                role: "navigation",
                "aria-label": "dropdown navigation",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "navbar-item has-dropdown-up is-hoverable is-small",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "is-small is-success button",
                      attrs: { id: "v-step-3" },
                    },
                    [_vm._v("Menu")]
                  ),
                  _c("div", { staticClass: "navbar-dropdown" }, [
                    !_vm.retrievingFSA
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item",
                            on: {
                              click: function ($event) {
                                _vm.showExportModal = true
                              },
                            },
                          },
                          [_vm._v(" Export Data ")]
                        )
                      : _vm._e(),
                    _c("hr", { staticClass: "navbar-divider" }),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              `/Environments?id=${_vm.$route.query.id}`
                            )
                          },
                        },
                      },
                      [_vm._v(" Toggle Environment ")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
      _c("notifications", { attrs: { group: "fsa", position: "bottom left" } }),
      _c("notifications", {
        staticClass: "export_notification",
        attrs: { group: "export", position: "top left" },
      }),
      _c("notifications", {
        attrs: { group: "zones", position: "bottom right" },
      }),
      _c("notifications", {
        attrs: { group: "lanes", position: "bottom center" },
      }),
      _c("notifications", {
        staticClass: "postal-code-search",
        attrs: { group: "postal_code_search", position: "top right" },
      }),
      _vm.mappingLoaded
        ? _c("FSASelector", {
            attrs: {
              showFSASelector: _vm.showFSASelector,
              retrievingFSA: _vm.retrievingFSA,
            },
            on: {
              closeModal: function ($event) {
                _vm.showFSASelector = false
              },
              selectFSAProvince: _vm.selectFSAProvince,
              closeSelectableFSAMode: _vm.closeSelectableFSAMode,
            },
          })
        : _vm._e(),
      _vm.mappingLoaded
        ? _c("ExportModal", {
            attrs: { showExportModal: _vm.showExportModal },
            on: {
              closeModal: function ($event) {
                _vm.showExportModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }